import getUpdatedComponentsByUuid from "reducers/lockingSystemReducer/utils/getUpdatedComponentsByUuid"
import getUpdatedMatrix from "reducers/lockingSystemReducer/utils/getUpdatedMatrix"
import getLockingSystemPricePortions, {
	getLockingSystemMsrpPricePortions,
} from "reducers/lockingSystemReducer/utils/getLockingSystemPricePortions"

import {
	DispatchLockingSystemReducer,
	LockingSystemReducerState,
} from "reducers/lockingSystemReducer"

type DeleteLockingComponentsPayload = Pick<
	LockingSystemReducerState,
	| "lockingComponentsUuids"
	| "componentsByUuid"
	| "matrix"
	| "matrixType"

	// Price
	| "singleNetPriceCents"
	| "singleGrossPriceCents"
	| "totalNetPriceCents"
	| "totalGrossPriceCents"

	// Msrp price
	| "singleNetMsrpPriceCents"
	| "singleGrossMsrpPriceCents"
	| "totalNetMsrpPriceCents"
	| "totalGrossMsrpPriceCents"
>

export const deleteLockingComponents = (
	dispatch: DispatchLockingSystemReducer,
	reducerState: LockingSystemReducerState,
	uuids: string[],
) => {
	const { keyComponentsUuids, quantity } = reducerState

	const removedLockingComponentRowIndices = reducerState.lockingComponentsUuids.reduce(
		(removedLockingComponentRowIndices, uuid, lockingComponentRowIndex) => {
			if (uuids.includes(uuid)) {
				return [...removedLockingComponentRowIndices, lockingComponentRowIndex]
			}

			return removedLockingComponentRowIndices
		},
		[] as number[],
	)
	const lockingComponentsUuids = reducerState.lockingComponentsUuids.filter(
		(uuid) => !uuids.includes(uuid),
	)

	// Remove matrix rows of removed components
	const updatedMatrix = reducerState.matrix.filter((_, rowIndex) => {
		return !removedLockingComponentRowIndices.includes(rowIndex)
	})

	const { matrix, matrixType } = getUpdatedMatrix(
		lockingComponentsUuids,
		keyComponentsUuids,
		updatedMatrix,
	)

	const componentsByUuid = getUpdatedComponentsByUuid(
		[...lockingComponentsUuids, ...keyComponentsUuids],
		reducerState.componentsByUuid,
	)

	const { singleNetPriceCents, singleGrossPriceCents, totalNetPriceCents, totalGrossPriceCents } =
		getLockingSystemPricePortions(componentsByUuid, quantity)

	const {
		singleNetMsrpPriceCents,
		singleGrossMsrpPriceCents,
		totalNetMsrpPriceCents,
		totalGrossMsrpPriceCents,
	} = getLockingSystemMsrpPricePortions(componentsByUuid, quantity)

	const payload: DeleteLockingComponentsPayload = {
		lockingComponentsUuids,
		componentsByUuid,
		matrix,
		matrixType,

		// Price
		singleNetPriceCents,
		singleGrossPriceCents,
		totalNetPriceCents,
		totalGrossPriceCents,

		// Msrp price
		singleNetMsrpPriceCents,
		singleGrossMsrpPriceCents,
		totalNetMsrpPriceCents,
		totalGrossMsrpPriceCents,
	}

	dispatch({
		type: "DELETE_LOCK_COMPONENTS",
		payload,
	})
}
